import React, { useEffect, useRef, useState } from "react";
import Alert from "../../../common/elements/Alert";
import {
  StyledInfoMessage,
  StyledLink,
  StyledMessage,
  StyledSignInContainer,
  StyledTextFieldWrapper,
  StyledTimerText,
} from "../../LandingPage/Header/StyledComponent";
import {
  makeStyles,
  Popover,
  TextField,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import Button from "../../../common/elements/Button";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Colors from "../../../common/materials/colors";
import AuthService from "../../../components/auth/AuthService";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import styled from "styled-components";
import {
  login,
  forgotPassword,
  resendOTP,
  signInOtop,
  resetPassword,
} from "../../LandingPage/Services";
import {
  getEmailFromUrlParams,
  joinedAuction,
  updateStore,
} from "../../LandingPage/Header/SignIn";
import ButtonComp from "../../../common/elements/Button";
import mixpanel from "mixpanel-browser";
import { useDialog } from "../../../common/elements/Dialog/Dialog";
import SignUpFormDialog from "../Dialogs/SignUpForm";
import { SignUpModalOptions } from "../Dialogs/SignUp";

const StyledOtherOptionWrapper = styled(Grid)`
  @media screen and (max-width: 400px) {
    justify-content: center;
    gap: 5px;
    text-align: center;
  }
`;

const useStyles = makeStyles((theme) => ({
  asterisk: { color: Colors.red },
  root: { display: "flex", flexWrap: "wrap" },
  input: { background: Colors.white },
  margin: { margin: theme.spacing(1) },
  signInButton: { width: "44px", height: "44px", position: "relative" },
}));

const ForgetPassword = ({
  emailRef,
  otpSentForgotPassword,
  passwordRef,
  otpRef,
  newPasswordRef,
}: {
  emailRef: React.MutableRefObject<null>;
  passwordRef: React.MutableRefObject<null>;
  otpRef: React.MutableRefObject<null>;
  newPasswordRef: React.MutableRefObject<null>;
  otpSentForgotPassword: boolean;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container alignItems="center" justifyContent="center">
      {otpSentForgotPassword ? (
        <Grid alignItems="center" justifyContent="center">
          <StyledTextFieldWrapper fullWidth className={classes.margin}>
            <TextField
              InputProps={{ className: classes.input }}
              label={t("common:profile:forgotPassword:labels:newPassword")}
              type="password"
              required
              inputRef={newPasswordRef}
              variant="outlined"
              id="new-password"
              autoComplete="off"
            />
          </StyledTextFieldWrapper>
          <StyledTextFieldWrapper fullWidth className={classes.margin}>
            <TextField
              InputProps={{ className: classes.input }}
              label={t("common:profile:forgotPassword:labels:confirmPassword")}
              type="password"
              required
              inputRef={passwordRef}
              variant="outlined"
              id="confirm-password"
              autoComplete="off"
            />
          </StyledTextFieldWrapper>
          <Typography align="center" paragraph>
            {t("common:newLandingPage:otpText")}
          </Typography>
          <TextField
            InputProps={{ className: classes.input }}
            label={t("common:profile:forgotPassword:labels:otp")}
            type="text"
            required
            inputRef={otpRef}
            variant="outlined"
            id="otp"
            autoComplete="off"
          />
        </Grid>
      ) : (
        <StyledTextFieldWrapper fullWidth className={classes.margin}>
          <TextField
            type="email"
            label={t("common:login:labels:email")}
            inputRef={emailRef}
            variant="outlined"
            id="email"
          />
        </StyledTextFieldWrapper>
      )}
    </Grid>
  );
};

export const SignInForm = ({
  showSignInWithOTP,
  emailRef,
  passwordRef,
  otpRef,
  emailSubmitted,
}: {
  emailSubmitted: boolean;
  showSignInWithOTP: boolean;
  emailRef: React.MutableRefObject<null>;
  otpRef: React.MutableRefObject<null>;
  passwordRef: React.MutableRefObject<null>;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [email, setEmail] = useState(getEmailFromUrlParams());
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e: { target: { value: string } }) => {
    setEmail(e.target.value);
  };

  return (
    <Grid container>
      {!emailSubmitted && (
        <StyledTextFieldWrapper fullWidth className={classes.margin}>
          <TextField
            InputProps={{ className: classes.input }}
            type="email"
            label={t("common:login:labels:email")}
            inputRef={emailRef}
            variant="outlined"
            id="email"
            value={email}
            onChange={handleChange}
            autoComplete="off"
          />
        </StyledTextFieldWrapper>
      )}

      {showSignInWithOTP && emailSubmitted ? (
        <Grid container justifyContent="center">
          <Typography align="center" style={{ fontSize: "0.8em" }} paragraph>
            {t("common:newLandingPage:otpText")}
          </Typography>
          <TextField
            InputProps={{ className: classes.input }}
            label={t("common:profile:forgotPassword:labels:otp")}
            type="text"
            required
            inputRef={otpRef}
            variant="outlined"
            id="otp"
            autoComplete="off"
          />
        </Grid>
      ) : (
        !showSignInWithOTP && (
          <StyledTextFieldWrapper fullWidth className={classes.margin}>
            <TextField
              label={t("common:login:labels:password")}
              type={showPassword ? "text" : "password"}
              inputRef={passwordRef}
              variant="outlined"
              id="password"
              autoComplete="off"
              InputProps={{
                className: classes.input,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </StyledTextFieldWrapper>
        )
      )}
    </Grid>
  );
};

export const ZipangSignIn = ({
  handleClose,
  setSuccessMessage,
  showForgotPassword = false,
  handleSignUpModal,
}: {
  showForgotPassword?: boolean;
  handleClose: () => void;
  setSuccessMessage?: (msg: string) => void;
  handleSignUpModal?: () => void;
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [createDialog, closeDialog] = useDialog();

  // State Management
  const [showSignInWithOTP, setShowSignInWithOTP] = useState(false);
  const [showForgetPassword, setShowForgetPassword] =
    useState(showForgotPassword);
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [otpSentForgotPassword, setOtpSentForgotPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [resetEnabled, setResetEnabled] = useState(true);
  const [timer, setTimer] = useState(30);

  // Refs
  const emailRef = useRef<any>(null);
  const passwordRef = useRef<any>(null);
  const forgotEmailRef = useRef<any>(null);
  const otpRef = useRef<any>(null);
  const newPasswordRef = useRef<any>(null);

  const dispatch = useDispatch();
  const history = useHistory();

  // FIX: This function ensures the Signup Modal works even when used outside the Header.
  const openSignUpModalFallback = () => {
    if (handleSignUpModal) {
      handleSignUpModal();
    } else {
      createDialog({
        children: (
          <SignUpFormDialog
            isMobile={isMobile}
            onSignUp={closeDialog}
            close={closeDialog}
          />
        ),
        ...SignUpModalOptions,
      });
    }
  };

  const validateEmail = (email: string) =>
    /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,20}$/g.test(email);

  const emailValidations = (email: string, password: string) => {
    if (!email) return t("common:register:errorMessage:emptyEmail");
    if (!validateEmail(email))
      return t("common:register:errorMessage:newonEmail");
    if (!password) return t("common:login:validation:invalidEmailorPassword");
    return "";
  };

  const processLoginResponse = (status: number, response: any) => {
    if (status === 200) {
      updateStore(dispatch);
      joinedAuction(history);
      return;
    }
    if (status > 200 && status < 500) {
      setMessage(response[0]?.message || t("common:invalidRequest"));
    }
  };

  const handleLogin = async () => {
    let username = emailRef.current?.value?.toLowerCase() || "";
    const password = passwordRef.current?.value || "";
    const errorMessage = emailValidations(username, password);
    setMessage(errorMessage);

    if (!errorMessage) {
      setIsLoading(true);
      const { status, response } = await login({ username, password });
      setIsLoading(false);
      localStorage.setItem("email", username);
      mixpanel.identify(username);
      mixpanel.track("User Login");
      processLoginResponse(status, response);
    }
  };

  const handleEmailSubmitOfOTPLogin = async () => {
    setMessage("");
    let email = emailRef.current?.value?.toLowerCase() || "";
    if (!email) return setMessage(t("common:register:errorMessage:emptyEmail"));
    if (!validateEmail(email))
      return setMessage(t("common:register:errorMessage:onEmail"));

    setIsLoading(true);
    const { status } = await resendOTP(email);
    setIsLoading(false);

    if (status === 200) {
      localStorage.setItem("email", email);
      setEmailSubmitted(true);
      setResetEnabled(false);
      setTimer(30);
    } else {
      setMessage(t("common:invalidRequest"));
    }
  };

  const handleLoginWithOTP = async () => {
    const otp = otpRef.current.value;
    const email: any = localStorage.getItem("email");
    localStorage.setItem("changePlanEmail", email);
    const { status, response } = await signInOtop({
      username: email.toLowerCase(),
      password: otp,
      type: "OTP",
    });

    mixpanel.identify(email);

    // // Track an event. It can be anything, but in this example, we're tracking a Sign Up event.
    mixpanel.track("Sign Up", {
      "Signup Type": "Referral",
    });
    mixpanel.people.set({
      $email: email,
      $name: email,
    });

    mixpanel.track("User OTP Login");

    if (status === 200) {
      Auth.setToken(response.token);
      localStorage.setItem("otpAuth", "true");
    }
    processLoginResponse(status, response);
  };

  const handleForgotPasswordEmailSubmit = async () => {
    setMessage("");
    let email = forgotEmailRef.current?.value?.toLowerCase() || "";
    if (!validateEmail(email))
      return setMessage(t("common:register:errorMessage:onEmail"));

    setIsLoading(true);
    const { status, response } = await forgotPassword(email);
    setIsLoading(false);

    if (status === 200) {
      localStorage.setItem("email", email);
      setInfoMessage(response.data.message);
      setOtpSentForgotPassword(true);
      setResetEnabled(false);
      setTimer(30);
    } else {
      setMessage(
        t("common:profile:forgotPassword:validation:notRegisteredEmail"),
      );
    }
  };

  const handleNewPassword = async () => {
    const otp = otpRef.current.value;
    const newPass = newPasswordRef.current?.value;
    const email = localStorage.getItem("email") || "";

    setIsLoading(true);
    const { status, response } = await resetPassword(email, newPass, otp);
    setIsLoading(false);

    if (status === 200) {
      handleClose();
      setSuccessMessage && setSuccessMessage(response.data.message);
    } else {
      setMessage(response[0]?.message || t("common:invalidRequest"));
    }
  };

  const handleReSendCode = async () => {
    setResetEnabled(false);
    setTimer(30);
    const email = localStorage.getItem("email") || "";
    if (showForgetPassword) {
      await forgotPassword(email);
    } else {
      await resendOTP(email);
    }
  };

  useEffect(() => {
    let interval: any;
    if (!resetEnabled && timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    } else if (timer === 0) {
      setResetEnabled(true);
    }
    return () => clearInterval(interval);
  }, [resetEnabled, timer]);

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      {showForgetPassword ? (
        <ForgetPassword
          emailRef={forgotEmailRef}
          passwordRef={passwordRef}
          newPasswordRef={newPasswordRef}
          otpRef={otpRef}
          otpSentForgotPassword={otpSentForgotPassword}
        />
      ) : (
        <SignInForm
          otpRef={otpRef}
          emailSubmitted={emailSubmitted}
          showSignInWithOTP={showSignInWithOTP}
          emailRef={emailRef}
          passwordRef={passwordRef}
        />
      )}

      <Grid container>
        <StyledMessage>{message}</StyledMessage>
        <StyledInfoMessage>{infoMessage}</StyledInfoMessage>
      </Grid>

      {showForgetPassword && (
        <Grid container justifyContent="space-between" alignItems="center">
          {!otpSentForgotPassword ? (
            <Button
              disabled={isLoading}
              type="contained-red"
              noMargin
              onClick={handleForgotPasswordEmailSubmit}
            >
              {t("common:kycFrom:submit")}
            </Button>
          ) : (
            <Button
              disabled={isLoading}
              type="contained-red"
              noMargin
              onClick={handleNewPassword}
            >
              {t("common:profile:forgotPassword:button:update")}
            </Button>
          )}
          {otpSentForgotPassword &&
            (resetEnabled ? (
              <StyledLink onClick={handleReSendCode}>
                {t("common:button:resendOtp")}
              </StyledLink>
            ) : (
              <StyledTimerText>{timer}s</StyledTimerText>
            ))}
        </Grid>
      )}

      {!showForgetPassword && (
        <StyledOtherOptionWrapper
          container
          justifyContent="space-between"
          alignItems="center"
        >
          {!showSignInWithOTP && !emailSubmitted && (
            <Button
              disabled={isLoading}
              type="contained-red"
              noMargin
              onClick={handleLogin}
            >
              {t("common:login:title")}
            </Button>
          )}

          {showSignInWithOTP && !emailSubmitted && (
            <Button
              disabled={isLoading}
              type="contained-red"
              noMargin
              onClick={handleEmailSubmitOfOTPLogin}
            >
              {t("common:kycFrom:submit")}
            </Button>
          )}

          {showSignInWithOTP && emailSubmitted && (
            <Grid container justifyContent="space-between" alignItems="center">
              <Button
                disabled={isLoading}
                type="contained-red"
                noMargin
                onClick={handleLoginWithOTP}
              >
                {t("common:header:buttons:login")}
              </Button>
              {resetEnabled ? (
                <StyledLink onClick={handleReSendCode}>
                  {t("common:button:resendOtp")}
                </StyledLink>
              ) : (
                <StyledTimerText>{timer}s</StyledTimerText>
              )}
            </Grid>
          )}

          <div>
            {!showSignInWithOTP && (
              <StyledLink
                onClick={() => {
                  setMessage("");
                  setShowSignInWithOTP(true);
                }}
              >
                {t("common:button:otpSignIn")}
              </StyledLink>
            )}
            <br />
            {!showSignInWithOTP && (
              <StyledLink
                onClick={() => {
                  handleClose(); // Close the popover
                  openSignUpModalFallback(); // Open the signup dialog
                }}
              >
                {t("common:newUserSignUp")}
              </StyledLink>
            )}
            <br />
            {!showSignInWithOTP && (
              <StyledLink
                onClick={() => {
                  setMessage("");
                  setShowForgetPassword(true);
                }}
              >
                {t("common:login:forgotPassword")}
              </StyledLink>
            )}
          </div>
        </StyledOtherOptionWrapper>
      )}
    </Grid>
  );
};

const Auth = new AuthService();

const HeaderSignInMenu = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [createDialog, closeDialog] = useDialog();
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [message, setMessage] = useState("");
  const menuSpace = useRef<any>(null);

  const handleClick = () => setAnchorEl(menuSpace.current);
  const handleClose = () => setAnchorEl(null);

  const handleSignUpModal = () => {
    createDialog({
      children: (
        <SignUpFormDialog
          isMobile={isMobile}
          onSignUp={closeDialog}
          close={closeDialog}
        />
      ),
      ...SignUpModalOptions,
    });
  };

  useEffect(() => {
    if (getEmailFromUrlParams()) handleClick();
  }, []);

  const { t } = useTranslation();

  return (
    <div>
      <ButtonComp onClick={handleClick} type="contained-login-red">
        {message && <Alert showAlertMessage={message} alertType={""} />}
        <span id="sign-in">{t("common:header:buttons:loginNew")}</span>
      </ButtonComp>

      <span ref={menuSpace}></span>
      {!Auth.loggedIn() && (
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <StyledSignInContainer elevation={3}>
            <ZipangSignIn
              handleClose={handleClose}
              setSuccessMessage={setMessage}
              handleSignUpModal={handleSignUpModal}
            />
          </StyledSignInContainer>
        </Popover>
      )}
    </div>
  );
};

export default React.memo(HeaderSignInMenu);
